import o, { createContext as I, useRef as v, useState as x, useEffect as y, useCallback as p, useMemo as P } from "react";
import { PartnershipsSDK as D, PartnerVariantDefaultSizes as M } from "./index.mjs";
const z = I({}), F = (e) => {
  const t = v(new D({ environment: e.environment, accessToken: "" })), [s, r] = x(!1);
  return y(() => {
    (async () => e.ready && (e.token && (t.current = new D({ environment: e.environment, accessToken: e.token })), await t.current.loadAds(e.loadAdsParams), r(!0)))();
  }, [e.environment, e.loadAdsParams, e.ready, e.token]), /* @__PURE__ */ o.createElement(z.Provider, { value: { sdk: t.current, loaded: s, defaultPlacement: e.defaultPlacement } }, e.children);
}, S = () => o.useContext(z), O = ({
  variant: e,
  placement: t,
  filterFn: s
}) => {
  const r = p(s ?? (() => !0), [s]), { sdk: n, loaded: l, defaultPlacement: f } = S(), u = t ?? f, [a, d] = x(), m = p(() => {
    try {
      if (l && n.loaded) {
        const c = n.getAd(e, u, r);
        d(c);
      }
    } catch (c) {
      console.error(c);
    }
  }, [l, n.loaded, n, e, u, r]);
  return y(() => {
    try {
      a || m();
    } catch (c) {
      console.error(c);
    }
  }, [m]), { ad: a, refreshAd: m };
}, T = ({ ad: e, id: t, placement: s, variant: r, metadata: n }) => {
  const { sdk: l } = S();
  return P(() => l.generateMetadata({ ad: e, componentId: t, variant: r, placement: s, ...n }), [n, e, t, r, s]);
}, A = "partner-ads-dismissed", B = (e) => {
  const [t, s] = x(() => {
    try {
      const n = JSON.parse(sessionStorage.getItem(A) || "{}");
      return (n == null ? void 0 : n[e]) === !0;
    } catch {
      return !1;
    }
  }), r = p(() => {
    try {
      const n = JSON.parse(sessionStorage.getItem(A) || "{}");
      n[e] = !0, sessionStorage.setItem(A, JSON.stringify(n)), s(!0);
    } catch (n) {
      console.error("Error dismissing ad", n);
    }
  }, [e]);
  return { dismissed: t, onDismissed: r };
}, N = ({
  ad: e,
  variant: t,
  onClick: s,
  imgProps: r,
  clickButtonProps: n,
  id: l,
  metadata: f,
  placement: u
}) => {
  const { sdk: a, defaultPlacement: d } = S(), c = T({ ad: e, metadata: f, id: l, variant: t, placement: u ?? d }), g = a.generateHref(e, c);
  if (y(() => {
    if (e)
      try {
        a == null || a.trackImpression(e, c);
      } catch (h) {
        console.error("Error tracking ad impression", h);
      }
  }, [e]), !e)
    return null;
  const i = e.sizes.find((h) => h.type === t);
  if (!i)
    return null;
  const k = M[t], b = () => {
    s && s(e);
  }, E = /* @__PURE__ */ o.createElement("picture", null, /* @__PURE__ */ o.createElement("source", { srcSet: i.imgUrl }), /* @__PURE__ */ o.createElement(
    "img",
    {
      src: i.imgUrl,
      ...r,
      style: {
        maxWidth: "100%",
        height: "auto",
        width: k.width,
        ...(r == null ? void 0 : r.style) ?? {}
      }
    }
  ));
  return s ? /* @__PURE__ */ o.createElement(
    "button",
    {
      onClick: b,
      style: {
        border: 0,
        padding: 0,
        backgroundColor: "transparent",
        cursor: "pointer"
      },
      ...n
    },
    E
  ) : /* @__PURE__ */ o.createElement("a", { href: g, target: "_blank", rel: "noopener noreferrer" }, E);
};
class R extends o.Component {
  constructor(t) {
    super(t), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(t, s) {
    console.error("Error caught in PartnershipsSDK ErrorBoundary:", t, s);
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
const J = ({
  onDismissed: e,
  buttonProps: t,
  svgStyles: s
}) => /* @__PURE__ */ o.createElement(
  "button",
  {
    "aria-label": "close",
    onClick: e,
    onMouseEnter: (r) => r.currentTarget.style.backgroundColor = "lightgrey",
    onMouseLeave: (r) => r.currentTarget.style.backgroundColor = "white",
    ...t,
    style: {
      position: "absolute",
      top: 8,
      right: 8,
      backgroundColor: "white",
      cursor: "pointer",
      border: 0,
      borderRadius: "500px",
      padding: "6px",
      lineHeight: 1,
      color: "rgba(0, 0, 0, 0.54)",
      fontSize: "1.125rem",
      ...t == null ? void 0 : t.style
    }
  },
  /* @__PURE__ */ o.createElement(
    "svg",
    {
      focusable: "false",
      "aria-hidden": "true",
      viewBox: "0 0 24 24",
      "data-testid": "CloseIcon",
      style: {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        fill: "currentcolor",
        flexShrink: 0,
        transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        fontSize: "inherit",
        maxWidth: "100%",
        verticalAlign: "middle",
        color: "rgba(0, 0, 0, 0.54)",
        ...s
      }
    },
    /* @__PURE__ */ o.createElement("path", { d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })
  )
);
function H({
  placement: e,
  variant: t,
  closable: s,
  refreshKey: r,
  buttonProps: n,
  clickButtonProps: l,
  imgProps: f,
  svgStyles: u,
  onClick: a,
  id: d,
  metadata: m
}) {
  const { defaultPlacement: c } = S(), g = e ?? c, { ad: i, refreshAd: k } = O({ variant: t, placement: g }), { dismissed: b, onDismissed: E } = B(d), h = v(!1), w = i == null ? void 0 : i.sizes.find((C) => C.type === t);
  return y(() => {
    try {
      h.current ? k() : h.current = !0;
    } catch (C) {
      console.error("Error refreshing ad", C);
    }
  }, [r]), !i || !w || b ? null : /* @__PURE__ */ o.createElement(R, null, /* @__PURE__ */ o.createElement("div", { className: "relative", id: d }, /* @__PURE__ */ o.createElement(
    N,
    {
      ad: i,
      variant: t,
      placement: g,
      onClick: a,
      imgProps: f,
      clickButtonProps: l,
      id: d,
      metadata: m
    }
  ), s && /* @__PURE__ */ o.createElement(J, { onDismissed: E, buttonProps: n, svgStyles: u })));
}
export {
  N as PartnerAdInternal,
  H as PartnershipAd,
  J as PartnershipAdCloseButton,
  z as PartnershipsContext,
  R as PartnershipsErrorBoundary,
  F as PartnershipsProvider,
  O as useAd,
  T as useMetadata,
  B as useOnDismissed,
  S as usePartnerships
};
